// Máscaras e validações para o cadastro (evita erro de digitação)

export function maskCPF(value) {
  const d = String(value).replace(/\D/g, '').slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

export function maskPhone(value) {
  const d = String(value).replace(/\D/g, '').slice(0, 11);
  if (d.length <= 10) {
    // fixo: (00) 0000-0000
    return d
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d{1,4})$/, '$1-$2');
  }
  // celular: (00) 00000-0000
  return d
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{1,4})$/, '$1-$2');
}

export function isValidEmail(value) {
  if (!value) return true; // vazio é permitido (campo opcional)
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

// Valida CPF pelos dígitos verificadores
export function isValidCPF(value) {
  if (!value) return true; // vazio é permitido
  const cpf = String(value).replace(/\D/g, '');
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(cpf[i], 10) * (10 - i);
  let d1 = 11 - (sum % 11);
  if (d1 >= 10) d1 = 0;
  if (d1 !== parseInt(cpf[9], 10)) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(cpf[i], 10) * (11 - i);
  let d2 = 11 - (sum % 11);
  if (d2 >= 10) d2 = 0;
  return d2 === parseInt(cpf[10], 10);
}

export function maskDate(value) {
  const d = String(value || '').replace(/\D/g, '').slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

export function isValidDate(value) {
  if (!value) return true;
  const d = String(value).replace(/\D/g, '');
  if (d.length !== 8) return false;
  const day = parseInt(d.slice(0, 2), 10);
  const month = parseInt(d.slice(2, 4), 10);
  const year = parseInt(d.slice(4, 8), 10);
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;
  if (year < 1900 || year > 2100) return false;
  return true;
}

export function dateToIso(value) {
  if (!value) return '';
  const d = String(value).replace(/\D/g, '');
  if (d.length === 8) {
    const day = d.slice(0, 2);
    const month = d.slice(2, 4);
    const year = d.slice(4, 8);
    return `${year}-${month}-${day}`;
  }
  if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.split('T')[0];
  }
  return value;
}

export function isoToDate(value) {
  if (!value) return '';
  const clean = String(value).split('T')[0];
  const parts = clean.split('-');
  if (parts.length === 3 && parts[0].length === 4) {
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
  return maskDate(value);
}
